/**
 * Where a link to an engagement should land, for THIS reader.
 *
 * There are two engagement surfaces (docs/modules/my-records.md):
 *   /qm/engagements       the management list — needs engagements:edit
 *   /my/engagements/:id   the read-only detail — needs to be on the team
 *
 * Do NOT link everyone at the management list — a reader without the key
 * lands on an access wall. Route by what the reader holds instead: editors
 * get the page they can act on, everyone else gets the read-only one.
 *
 * @param {{id: number, engagementName?: string, entityName?: string}} engagement
 * @param {boolean} canEdit  hasPermission('engagements:edit')
 * @returns {string|null} href, or null when there is nothing to link to
 */
export const engagementHref = (engagement, canEdit) => {
  if (!engagement || !engagement.id) return null;
  // 管理面有自己的詳情頁,所以直接連那一筆。不要用
  // `/qm/engagements?search=<案名>` 這種清單加搜尋關鍵字**逼近**——撞名會列出
  // 多筆、案子改名就失效。
  return canEdit ? `/qm/engagements/${engagement.id}` : `/my/engagements/${engagement.id}`;
};

export default engagementHref;
